import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import useAnimation from '../../Hooks/useAnimation';
import darNoData from '../../Assets/images/json/dar_no_data.json'; // Provide the correct path to the module
import './targetDashboard.scss';

const NoTargetData = ({ message }) => {
  const animationContainer = useAnimation(darNoData); // Use the imported module

  return (
    <div className="no-target-container">
      <div className="no-target-contents">
        <div ref={animationContainer} className="no-target-image"></div>
        <Typography className="no-target-text">{message}</Typography>
      </div>
    </div>
  );
};

NoTargetData.propTypes = {
  message: PropTypes.string.isRequired,
};

export default NoTargetData;
